import config from 'config';
import get from 'lodash/get';

export default (state) => {
  return !!get(state, 'auth.organizations.selectedOrganizationToken', false) || !!Number(config.org_id);
};
